import React from "react";
import HseThresholdMetric from "./HseThresholdMetric";
import { Error, Loader } from "./common";
import { overviewChartPalette } from "styles/theme";

const NearMissRateAgeing = ({ nearMissFrequencyRate, isLoading, isError }) => {
    if (isLoading) return <Loader isLoading={isLoading} />;
    if (isError) return <Error isError={isError} />;
    const value = Number(nearMissFrequencyRate) || 0;
    const onTarget = value === 0;
    const attention = value > 3;
    const color = onTarget ? overviewChartPalette.teal : attention ? overviewChartPalette.coral : overviewChartPalette.amber;
    return <HseThresholdMetric eyebrow="Leading indicator" title="Near-Miss Frequency" subtitle="Near misses recorded per million work hours." value={value} status={onTarget ? "On target" : attention ? "Attention" : "Watch"} color={color} progress={Math.min((value / 3) * 100, 100)} benchmark="Target 0 · escalation threshold above 3" />;
};

export default NearMissRateAgeing;
